import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import '../../../../Assets/EnsembleStyles/EnsLogin.css';
import { authenticateUser,checkPasswordPolicy,changePassword,UpdateLogonTransaction } from '../../../../action/authenticateUser';
//import {GetTenantWorkOrderLicenseInfo} from '../../../../action/Administration/administrationAction';
import { Button, Modal } from 'reactstrap';
// import {FaQuestionCircle} from 'react-icons/fa';
import LoginLicenseTerms from '../../../common/Modals/loginLicenseTerms';
import ErrorGif from '../../../../Assets/images/Error.gif';
import * as ErrorMessage from '../../../../Resources/ErrorMessages';
import { identityCall, sendSingleAmplitudeEvent, setAmplitudeEvent } from 'amplitude/amplitude';
import { getServerType } from '../../../../action/Administration/license';


class LoginForm extends Component {  
    
    
    componentWillMount() {
        this.props.getServerType("FM");
    }
    
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {  
            //Login Successfull
            if (nextProps.login_response.loggedIn === true) {
                if(nextProps.login_response.token !== null && nextProps.login_response.user_type === "property_manager")
                {
                    var logondetails = {
                        "LogOnTransaction": true,
                        "LogOffType":null,
                        "LogOnTransactionId":null
                    }
                    
                    this.props.UpdateLogonTransaction(logondetails);
                }
                this.setState({
                    loggedIn: nextProps.login_response.loggedIn,
                    token: nextProps.login_response.token,
                    user_type: nextProps.login_response.user_type,
                    error_msg: false, error_msg_type: null,
                });
            }

            //Login Unsuccessfull   
            else if (nextProps.login_response.invalid_user === true) {
                this.setState({
                    error_msg: true,
                    error_msg_type: ErrorMessage.invalid_login_credentials,
                },()=>{setAmplitudeEvent("Logged_In",{"error type":"invalid credentials"}) });
            }

            //Login Success & Eula not accepted  or failed
            else if (nextProps.login_response.EULA === true) {
                this.setState({
                    error_msg: false, error_msg_type: null, EULA_redirect: true
                });
            }

            //Password Used in History 
            else if (nextProps.login_response.password_used_in_history === true) {
                this.setState({
                    error_msg: true,
                    password_used_in_history: true,
                    error_msg_type: ErrorMessage.password_used_in_history
                });
            }

            //Password Expired
            else if (nextProps.login_response.password_expired === true) {
                this.setState({
                    error_msg: false,
                    Password_Expired: true,
                    error_msg_type: ErrorMessage.password_expired
                });
            }

            //API not responding
            // else if (nextProps.login_response.API_not_responding === true) {
            //     this.setState({
            //         error_msg: true,
            //         error_msg_type: ErrorMessage.API_not_responding_msg,
            //     });
            // }

            //Forbidden
            else if (nextProps.login_response.user_forbidden === true) {
                this.setState({
                    error_msg: true,
                    error_msg_type: ErrorMessage.forbidden,
                });
            }
    }
}

    enterPressed = (event) => {
        var code = event.keyCode || event.which;
        if (code === 13) { //13 is the enter keycode
            this.authenticate();
        }
    } 

    authenticate = () => {
        let { username, password } = this.state;
        this.setState({
            error_msg: false, error_msg_type: null,
        });
        if (username === null || username === "" || username === undefined) {
            this.setState({
                error_msg: true,
                error_msg_type: ErrorMessage.no_values,
            },()=>{ setAmplitudeEvent("Logged_In",{"error type":"username empty"})});
        }
        else if( password === null || password === "" || password === undefined){
            this.setState({
                error_msg: true,
                error_msg_type: ErrorMessage.no_values,
            },()=>{setAmplitudeEvent("Logged_In",{"error type":"password empty"})});
        }
        else {
            let credentials = {
                "username": username,
                "password": password,
                "login_type": "property_manager"
            }
            localStorage.setItem('EULA_U', null);
            localStorage.setItem('EULA_P', null);
            localStorage.setItem('EULA_U', username);
            localStorage.setItem('EULA_P', password);
            this.props.authenticateUser(credentials);
            }
        }


    changePassword = () => {
        let {username, password, new_password, confirm_password } = this.state;

        this.setState({
            error_msg: false, error_msg_type: null,
        });
        if (username === null|| username === ""|| username === undefined|| password === null || password === "" || password === undefined|| new_password === null || new_password === "" || new_password === undefined||confirm_password === null || confirm_password === "" || confirm_password === undefined) {
            this.setState({
                error_msg: true,
                error_msg_type: ErrorMessage.no_values,
            });
        }
        else{
            if(new_password !== confirm_password ){
                this.setState({
                    error_msg: true,
                    error_msg_type: ErrorMessage.passwords_doesnt_match,
                });
            }
            else{
                let credentials = {
                    "username": username,
                    "password": password,
                    "newpassword": new_password,
                    "login_type": "property_manager"
                };
                let check_password_policy = {
                    "password": new_password,
                }
                this.props.checkPasswordPolicy(check_password_policy).then(response => {
                    
                    if(response.status === 200 && response.data.valid === false  ){
                       this.setState({
                           error_msg: true,
                           error_msg_type:ErrorMessage.passwords_strength
                       });
                    }else if(response.status === 200 && response.data.valid === true ){
                        localStorage.setItem('EULA_U', null);
                        localStorage.setItem('EULA_P', null);
                        localStorage.setItem('EULA_U', username);
                        localStorage.setItem('EULA_P', new_password);
                      this.props.changePassword(credentials)
                        }
                   })
            }

        }
    }


    constructor(props) {
        super(props);
        this.state = {
            error_msg: false,
            error_msg_type: null,
            license_modal: false,
            username: null,
            password: null,
            new_password: null,
            confirm_password: null,
            redirect: false,
            EULA_redirect: false,
            token: null,
            loggedIn: null,
            user_type: null,
            check_for_token: true,
            Password_Expired: false,
            password_used_in_history: false,
            forbidden: false,
        }
        this.licensetoggle = this.licensetoggle.bind(this);
        this.setAmplitude = this.setAmplitude.bind(this);
    }

    licensetoggle() {
        this.setState({
            license_modal: !this.state.license_modal
        });
    }

    CloseModal = (someArg) => {
        if (someArg === "Cancel") {
            this.licensetoggle()
        }
    }

    setAmplitude(){
        var eventProperties ={
            "userID":localStorage.getItem("TenantUserID"),
            "userRole":"Ensemble Administrator",
            "client":"Tenant Services on Trane Connect",
            "version":localStorage.getItem("Version"),
        }
        identityCall(eventProperties);
        sendSingleAmplitudeEvent("Logged_In");
    }

    render(getLicenseinfo) {
        let Error_Message, Expired_Password_form, Regular_form, Login_Form = null;
        let license_info = this.props.getLicenseinfo; 
        let licensed_features = license_info.licensedFeatures;
        let islicensed = (licensed_features !== undefined) ? licensed_features.length : 0;
        let { error_msg_type, EULA_redirect, token, loggedIn, user_type} = this.state;
        
        (this.state.error_msg === true) ? Error_Message = <p className="error_msg login_error_msg "> <img src={ErrorGif} alt="Trane Logo" />  {error_msg_type}</p> : Error_Message = "";
        // if (forbidden === true) {
        //     return <Redirect to={"/forbidden"} />
        // }
        // if (token !== null && loggedIn === true && user_type === "property_manager" && EULA_redirect === true) {
        //     return <Redirect to={"/LicenseAgreement"} />
        // }
        if (EULA_redirect === true) {
            return <Redirect to={"/LicenseAgreement"} />
        }
        // else if(token !== null && loggedIn === true && user_type === "property_manager" ){
        //     return <Redirect to={"/managetenant"}/>
        // }
            
        else if (token !== null && loggedIn === true && user_type === "property_manager" && islicensed !== 0 && licensed_features !== undefined) {
            this.setAmplitude();
            if( licensed_features[0].licensed === true)
                return <Redirect to={"/managetenant"} />
            else if( licensed_features[1].licensed === true)
                return <Redirect to={"/ManageWorkOrder"}/>
            else
                return<Redirect to={"/SystemAdmin/Administration"}/>
        }
        else if( islicensed === 0 && loggedIn === true){
            this.setAmplitude();
            return <Redirect to={"/SystemAdmin/Administration"}/>
        }
     
       
// Login regular Form

        Regular_form = <form className="login_form_fields">
                            <div className="form-group ">
                                <input type="text" placeholder="User ID" className="form-control form-control-sm login_input" required onKeyPress={this.enterPressed} onChange={e => this.setState({ username: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <input type="password" id="password" placeholder="Password" className="form-control form-control-sm login_input" required onKeyPress={this.enterPressed}  onChange={e => this.setState({ password: e.target.value })} />
                            </div>
                            <Button type="button" className="btn btn-sm login_submit_btn" onClick={() => { this.authenticate() }}   >{"Log In"}   </Button>
                  </form>;


// Expired password Form
            Expired_Password_form = <form className="login_form_fields">
                                            <div className="form-group">
                                                <input type="password" id="reg_password" placeholder="Password" className="form-control form-control-sm login_input" required onChange={e => this.setState({ password: e.target.value })} />
                                            </div>
                                            <p className="error_msg login_error_msg ">  {"Error: Your password has expired. Enter your new password below."}</p> 

                                            <div className="form-group">
                                                <input type="password" id="new_password" placeholder="New Password" className="form-control form-control-sm login_input" required onChange={e => this.setState({ new_password: e.target.value })} />
                                            </div>

                                            <div className="form-group">
                                                <input type="password" id="confirm_password" placeholder="Confirm Password" className="form-control form-control-sm login_input" required onChange={e => this.setState({ confirm_password: e.target.value })} />
                                            </div>
                                            <Button type="button" className="btn btn-sm login_submit_btn" onClick={() => { this.changePassword() }}   >{"Log In"}   </Button>
                                    </form>;


        (this.state.Password_Expired) ? Login_Form = Expired_Password_form : Login_Form = Regular_form;
        

        return (

            <div className="Ens_Login_area">

                <div className="login_form_header">
                    <h1 className="Ens_login_title" >Login </h1>
                    {/* <a href="http://tracerdemo.com/TracerES/Help/en-US/CSH_topics/Security/(SEC.G.1)_login.htm" target="_blank" rel="noopener noreferrer"><FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon link_cursor" /></a> */}
                </div>

                {Error_Message}
                {Login_Form} 
                <p className="login_area_copyright_text" >By accessing Trane Facility Services, you accept and agree to be bound by the
                 <span className="copyright_nav link_cursor" onClick={this.licensetoggle}> End-User License Agreement Terms and Conditions.</span></p>

                <Modal isOpen={this.state.license_modal} licensetoggle={this.licensetoggle} className="license_modal"  >
                    <LoginLicenseTerms CloseModal={this.CloseModal} />
                </Modal>

            </div>


        );
    }
}

const mapStateToProps = state => {
    return {
        login_response: state.authService,
        getLicenseinfo: state.InstallationsRootReducer.TenantWorkOrderLicense
    };
};

const mapDispatchToProps = dispatch => {
    return {
        authenticateUser: (credentials) => dispatch(authenticateUser(credentials)),
        checkPasswordPolicy: (check_password_policy) => dispatch(checkPasswordPolicy(check_password_policy)),
        changePassword: (credentials) => dispatch(changePassword(credentials)),
        UpdateLogonTransaction:(logondetails) => dispatch(UpdateLogonTransaction(logondetails)),
        getServerType: (featureName) => dispatch(getServerType(featureName)),
        // GetTenantWorkOrderLicenseInfo: () => dispatch(GetTenantWorkOrderLicenseInfo())      
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);

